import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {Invoice, InvoiceEntity} from "../../../model/invoice";

export interface InvoiceSelectorProps {
  regionId?: string
}

const getRegionIdParam = createParamSelector<InvoiceSelectorProps | undefined, string | undefined>(params => params?.regionId);

export const invoicesSelector = () => createSelector(
  [getUseQueryResultData<Invoice[]>, getRegionIdParam],
  (data, regionId) => {
    return selectInvoicesAndTransform(
      data ?? [], {
        regionId: regionId,
      }
    );
  }
);

export const invoiceSelector = () => createSelector(
  [getUseQueryResultData<Invoice>],
  (data) => {
    return data ? transformInvoice(data) : undefined;
  }
);

export const selectInvoices = (values?: Invoice[], selector?: InvoiceSelectorProps): Invoice[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (v.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformInvoice = (value: Invoice): InvoiceEntity => {
  return InvoiceEntity.from(value)
}

export const selectInvoicesAndTransform = (values?: Invoice[], selector?: InvoiceSelectorProps): InvoiceEntity[] => {
  const selected = selectInvoices(values, selector);
  return selected.map(transformInvoice);
};
